import { render, staticRenderFns } from "./CancelOrder.vue?vue&type=template&id=5ecd01c4&scoped=true"
import script from "./CancelOrder.vue?vue&type=script&lang=js"
export * from "./CancelOrder.vue?vue&type=script&lang=js"
import style0 from "./CancelOrder.vue?vue&type=style&index=0&id=5ecd01c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ecd01c4",
  null
  
)

export default component.exports